import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Eye, EyeClosed, X } from "lucide-react";
import TempStorage from "../../components/Storage.js";
import { Device } from '@capacitor/device';
import DeviceDetector from "../../components/DeviceDetector.js";
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";
import Tooltip from "../../components/Tooltip.js";
import { useDarkMode } from "../../components/DarkModeContext.js";

let infoUtente = [];
let isLoading = false;

const ResocontoPiano = ({ isVisible, infoCodice }) => {
    const navigate = useNavigate();

    const handleAnnulla = () => {
        const input = document.querySelector('input');
        input.removeAttribute('disabled');
        window.location.reload();
    };

    const handleConferma = async () => {
        try {
            isLoading = true;
            const response = await fetch('/aggiornaLicenzaDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ IDLicenza: infoCodice.ID, CodiceDominio: infoUtente.CodiceDominio }),
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                navigate('/');
            }
        } catch (error) {
            alert('Errore nella connessione al server');
            console.log(error);
            window.location.reload();
        }
    };

    if (!isVisible) return null;

    return (
        <div className="mt-1 text-center">
            <h2 className="mb-3">Revisione del piano</h2>
            <p className="mb-2">Nome: {infoCodice.Nome}</p>
            <p className="mb-2">Descrizione: {infoCodice.Descrizione}</p>
            <div className='mt-3 grid grid-cols-2'>
                <button
                    onClick={handleAnnulla}
                    className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                >
                    Annulla
                </button>
                <button
                    onClick={handleConferma}
                    className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                >
                    Conferma
                </button>
            </div>
        </div>
    );
};

const PopUp = ({ isVisible, setIsVisible }) => {
    const [infoCodiceAtt, setInfoCodiceAtt] = useState("");
    const [isResocontoVisible, setIsResocontoVisible] = useState(false);

    const checkCodice = async () => {
        try {
            isLoading = true;
            const response = await fetch('/checkCodiceAttivazione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceAtt: infoCodiceAtt }),
            });

            const data = await response.json();

            if (response.status === 200) {
                isLoading = false;
                if (data[0].Obsoleto) {
                    alert('Licenza obsoleta');
                    return;
                };

                if (data[0].DataAttivazione !== null) {
                    alert('Licenza già utilizzata');
                    return;
                };

                setInfoCodiceAtt(data[0]);
                setIsResocontoVisible(true);
            }
            else {
                alert(data["error"]);
            }
        } catch (error) {
            alert('Errore nella connessione al server');
            console.log(error);
            window.location.reload();
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-center items-center mb-6">
                    <h2 className="text-xl font-bold justify-self-center">La tua licenza è scaduta</h2>
                </div>
                <div className="justify-self-center">
                    <p>Inserire la nuova licenza</p>
                    <input
                        type="text"
                        placeholder=""
                        value={infoCodiceAtt.CodiceAttivazione}
                        onChange={(e) => setInfoCodiceAtt(e.target.value)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 w-full"
                        onBlur={checkCodice}
                    />
                </div>
                <ResocontoPiano isVisible={isResocontoVisible} infoCodice={infoCodiceAtt} />
            </div>
        </div>
    );
};

const PopUpDownload = ({ isVisible, setIsVisible }) => {

    const [devices, setDevices] = useState({
        MacOS: ["/MacOS.png", "/downloads/MANTEGO.dmg"],
        Windows: ["/Windows.png", "/downloads/MANTEGO.exe"],
        Linux: ["/Linux.png", "/downloads/MANTEGO.deb"],
        Android: ["/Android.png", "/downloads/MANTEGO.apk"],
        iOS: ["/iOS.png"],
    });

    // useEffect(() => {
    //     if (isVisible) {
    //         const infoDevice = DeviceDetector.getOS();
    //         console.log(infoDevice);
    //     }
    // }, [isVisible]);

    const closeModal = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">SCARICA L'APPLICAZIONE</h2>
                    <Tooltip content="Chiudi">
                        <button className="text-red-500" onClick={closeModal}>
                            <X size={24} />
                        </button>
                    </Tooltip>
                </div>
                <div className="flex aling-items-center justify-items-center grid grid-cols-1 gap-2">
                    <div>
                        <button className="bg-white text-white font-bold rounded border-2 p-1 m-1 border-black shadow-lg" onClick={() => {
                            if (DeviceDetector.getOS() === 'iOS') {
                                alert("L'applicazione arriverà presto su iOS, intanto potete installare l'applicazione web tramite Safari in questo modo: \n1. Cliccare sul pulsante 'Condividi' in basso al centro \n2. Cliccare su 'Aggiungi a schermata Home' \n(Se questa azione non fosse disponibile inizialmente è possibile aggiungerla andando sul pulsante 'Modifica azioni' che si trova nella parte inferiore della scheda di condivisione.) \n3. Cliccare su 'Aggiungi' in alto a destra");
                            }
                            else {
                                window.location.href = devices[DeviceDetector.getOS()][1];
                            }
                        }}>
                            <img src={devices[DeviceDetector.getOS()][0]} width={90}></img>
                        </button>
                    </div>
                    <div>
                        Oppure
                    </div>
                    <div className="flex aling-items-center justify-items-center">
                        {
                            Object.keys(devices).map((device) => {
                                if (device === DeviceDetector.getOS()) return null;
                                return (
                                    <button className="bg-white text-white font-bold rounded border-2 p-1 m-1 border-black shadow-lg" onClick={() => {
                                        if (device === 'iOS') {
                                            alert("L'applicazione arriverà presto su iOS, intanto potete installare l'applicazione web tramite Safari in questo modo: \n1. Cliccare sul pulsante 'Condividi' in basso al centro \n2. Cliccare su 'Aggiungi a schermata Home' \n(Se questa azione non fosse disponibile inizialmente è possibile aggiungerla andando sul pulsante 'Modifica azioni' che si trova nella parte inferiore della scheda di condivisione.) \n3. Cliccare su 'Aggiungi' in alto a destra");
                                        }
                                        else {
                                            window.location.href = devices[device][1];
                                        }
                                    }}>
                                        <img src={devices[device][0]} width={90}></img>
                                    </button>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const [isPopUpDonwloadVisible, setIsPopUpDonwloadVisible] = useState(false);
    const [installPrompt, setInstallPrompt] = useState(null);
    const navigate = useNavigate();
    const {loadCorrectTheme} = useDarkMode();

    const inputRefs = useRef([]);

    useEffect(() => {
        if (TempStorage.exists('authAlert')) {
            alert(TempStorage.get('authAlert'));
        }
        TempStorage.clear();

        const handleBeforeInstallPrompt = (event) => {
            // Previene il prompt automatico del browser
            event.preventDefault();
            // Salva l'evento per utilizzarlo successivamente
            setInstallPrompt(event);
        };

        // Listener per l'evento di installazione
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };

    }, []);

    const handleLogin = async () => {
        try {
            isLoading = true;
            const infoDevice = await Device.getId();
            const response = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email, Password: password, CodiceDispositivo: infoDevice["identifier"] }),
            });
            const data = await response.json();
            if (response.status === 401) {
                alert(data['error']);
                setEmail('');
                setPassword('');
            }
            else if (response.status === 201) {
                infoUtente = data;
                setIsPopUpVisible(true);
            }
            else if (response.status === 202) {
                alert(data["warning"]);
                successLogin(data["user"]);
            }
            else if (response.status === 200) {
                isLoading = false;
                successLogin(data);
            }
        } catch (error) {
            console.error(error);
            alert('Errore durante il login');
            // alert(error);
            setEmail('');
            setPassword('');
        }
    };

    const successLogin = (data) => {
        loadCorrectTheme(false, data['ID']);
        switch (data['Livello']) {
            case 'Manager':
                TempStorage.set('tokenManager', data['ID']);
                document.cookie = `tokenManager=${data['ID']}; path=/;`;
                navigate('/dashManager');
                break;
            case 'IS':
                TempStorage.set('tokenDev', data['ID']);
                document.cookie = `tokenDev=${data['ID']}; path=/;`;
                navigate('/dashDev');
                break;
            case 'Utente':
                TempStorage.set('tokenUser', data['ID']);
                document.cookie = `tokenUser=${data['ID']}; path=/;`;
                navigate('/dashUtente');
                break;
            case 'Venditore':
                TempStorage.set('tokenVenditore', data['ID']);
                document.cookie = `tokenVenditore=${data['ID']}; path=/;`;
                navigate('/dashVenditore');
                break;
            default:
                alert('Ruolo non riconosciuto');
                handleAnnulla();
        }
    }

    const handleDominio = () => {
        navigate('/dominio');
    }

    const handleAnnulla = async () => {
        setEmail('');
        setPassword('');
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    return (
        <div className="flex justify-center min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"MANTEGO"} />
            <div className="p-4 w-full max-w-lg text-center relative bg-white dark:bg-gray-800 text-black dark:text-white">
                <h1 className="mb-5 mt-14">BENTORNATO</h1>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Email: </p>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                        ref={(el) => (inputRefs.current[0] = el)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                    />
                </div>
                <div className="mb-2 grid grid-cols-2 items-center">
                    <p className="justify-self-start">Password: </p>
                    <div className="relative flex items-center">
                        <input
                            type={isPasswordVisible ? "text" : "password"}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleLogin();
                                }
                            }}
                            ref={(el) => (inputRefs.current[1] = el)}
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 flex-1"
                        />
                        <Tooltip content="Mostra password">
                            <button
                                type="button"
                                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                className="absolute right-2 text-gray-500 hover:text-gray-700"
                            >
                                {isPasswordVisible ? (
                                    <EyeClosed size={20} />
                                ) : (
                                    <Eye size={20} />
                                )}
                            </button>
                        </Tooltip>
                    </div>
                </div>

                <div className='mb-5 grid grid-cols-2'>
                    <button
                        onClick={handleAnnulla}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleLogin}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Accedi
                    </button>
                </div>
                <p>Non hai le credenziali?<br />Contatta il tuo manager oppure <b><u className="text-blue-600 cursor-pointer" onClick={handleDominio}>attiva una licenza</u></b></p>
                <div className="mt-4">
                    <p><b><u className="text-blue-600 cursor-pointer" onClick={() => setIsPopUpDonwloadVisible(true)}>SCARICA LA NOSTRA APP</u></b></p>
                </div>
            </div>
            <PopUp isVisible={isPopUpVisible} setIsVisible={setIsPopUpVisible} />
            <PopUpDownload isVisible={isPopUpDonwloadVisible} setIsVisible={setIsPopUpDonwloadVisible} />
        </div>
    );
};

export default Login;
